module.exports = __webpack_public_path__ + "static/media/bts_lalela_170705_007_small.3d235f31.jpg";